/* eslint-disable import/prefer-default-export */
export const recommendedCoursesFilterTypes = [
  {
    _id: 'true',
    name: 'Free',
  },
  {
    _id: 'false',
    name: 'Paid',
  },
];

export const showEnrollment = (
  courseInfo: { registration?: any; registrationStartDate?: string },
  currentTime: string
) => {
  const startDate = courseInfo?.registration?.startDate || courseInfo?.registrationStartDate;
  if (startDate && new Date(startDate).getTime() > new Date(currentTime).getTime()) {
    return false;
  }
  return true;
};

export const handleEnrollmentData = (courseInfo: { userCount?: number }) => {
  if ((courseInfo?.userCount || 0) > 500) {
    return '1000+';
  }
  if ((courseInfo?.userCount || 0) > 100) {
    return '500+';
  }
  return courseInfo?.userCount || 0;
};
